import { loginRequest } from '@js/authConfig';
import { useMsal } from '@auth';
import log, { LogContext } from '@utils/logging';

const useLogin = () => {
    const { instance } = useMsal();

    const login = () => {
        log({
            context: LogContext.User,
            title: 'Logged in',
            reason: 'The user logged in',
        });

        // Encode the current origin so the production redirect handler can
        // bounce the user back to this preview branch after login completes.
        instance.loginRedirect({ ...loginRequest, state: window.location.origin })
            .catch((e) => {
                console.error(e);
            });
    };

    return login;
};

export default useLogin;
